import { render } from "./DocumentCompany.vue?vue&type=template&id=de27e272&scoped=true"
import script from "./DocumentCompany.vue?vue&type=script&lang=js"
export * from "./DocumentCompany.vue?vue&type=script&lang=js"

import "./DocumentCompany.vue?vue&type=style&index=0&id=de27e272&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-de27e272"]])

export default __exports__